import {type PayloadAction, createSlice} from '@reduxjs/toolkit';

import type {AppState} from 'src/store/typedef';

export type InitialState = {
    selectedColumns: string[],
};

const initialState: InitialState = {
    selectedColumns: [],
};

export const accountSearchResultColumns = createSlice({
    name: 'assignedAccountsSearchResultColumns',
    initialState,
    reducers: {
        updateSelectedAccountSearchColumns: (state, action: PayloadAction<string[]>) => {
            state.selectedColumns = action.payload;
        },
        clearSelectedColumns: state => {
            state.selectedColumns = [];
        },
    },
});

export const {
    updateSelectedAccountSearchColumns,
    clearSelectedColumns,
} = accountSearchResultColumns.actions;

export const selectSelectedColumns = (state: AppState) =>
    state.userPage.tabs.assignedAccounts.columns.selectedColumns;
